<template>
  <CoverUploadWidget @saveImage="saveCover($event)"
                     @removeImage="deleteCover()"
                     :image-key="companyInfo.companyImageCover"/>
  <div class="container container-fixed-992 pb-5">
    <div class="row row-user-avatar">
      <div class="col-12 mb-4">
        <div v-if="uploading" class="user-avatar">
          <div class="img-avatar skeleton imageM"></div>
        </div>
        <AvatarWidget
            v-else
            :image-key="companyInfo.companyImage"
            image-size="imageL"
            :full-name-avatar="companyNameAvatar"
            :alt="companyName.inputValue"
            :title="companyName.inputValue">
        </AvatarWidget>
      </div>
      <div class="col-12 col-xl-10">
        <h1 class="user-name">{{ companyName.inputValue }}</h1>
        <div class="buttons vertical-middle">
            <span class="me-1">
              <PhotoUploadWidget @saveImage="saveAvatar($event)"
                                 :image-key="companyInfo.companyImage"
                                 image-size="imageL"
                                 button-label="Upload Logo"/>
            </span>
        </div>
      </div>
    </div>
  </div>

</template>
<script lang="ts">
import {defineComponent} from 'vue'
import PhotoUploadWidget from '@shared/components/widgets/photo-upload/photo-upload.widget.vue'
import CoverUploadWidget from '@shared/components/widgets/photo-upload/cover-upload.widget.vue'
import AvatarWidget from '@shared/components/widgets/profile/avatar.widget.vue'
import {AccountNs, CommonNs, SettingNs} from '@shared/types'
import {useWorkspaceStore} from "@shared/stores/workspace.store";
import {mapStores} from "pinia";
import {useCompanyStore} from "@domains/settings/stores/company.store";
import {useGeneralStore} from "@shared/stores/general.store";
import {toast} from '@shared/ms-components'

export default defineComponent({
  name: 'CompanyHeaderCardWidget',
  components: {
    AvatarWidget,
    PhotoUploadWidget,
    CoverUploadWidget
  },
  data() {
    return {
      companyCoverImage: '',
      uploading: false
    }
  },
  computed: {
    ...mapStores(useWorkspaceStore, useCompanyStore, useGeneralStore),
    companyName(): AccountNs.AccountProperty {
      return this.companyStore.getCompanyInfo.companyProperties.find((c: AccountNs.AccountProperty) => c.name === 'companyName')
    },
    companyNameAvatar() {
      const companyName = this.companyName.inputValue
      return companyName.substring(0, 1).toUpperCase()
    },
    companyInfo(): SettingNs.CompanyInfo {
      return this.companyStore.getCompanyInfo
    },
  },
  methods: {
    saveCover(fileData: CommonNs.ImageData) {
      const data = new FormData()
      data.append('file', new File([fileData.file], fileData.name, {type: fileData.type}))

      this.companyStore.uploadCompanyCover(data)
          .then(() => {
            this.companyStore.loadCompanyInfo({workspaceId: this.workspaceStore.getSelectedWorkspaceId}).then(() => {
            })
            toast.success('Saved')
          })
    },
    deleteCover() {
      const companyInfo = this.companyStore.getCompanyInfo;
      if (companyInfo.companyImageCover) {
        this.companyStore.removeCompanyCover(companyInfo.companyImageCover).then(() => {
        })
      }
    },
    saveAvatar(fileData: CommonNs.ImageData) {
      if (fileData) {
        document.getElementById('photoUploadButton')?.click()
        this.uploading = true
        const data = new FormData()
        data.append('file', new File([fileData.file], fileData.name, {type: fileData.type}))

        this.companyStore.uploadCompanyAvatar(data)
            .then(() => {
              this.companyStore.loadCompanyInfo({workspaceId: this.workspaceStore.getSelectedWorkspaceId}).then(() => {
                this.uploading = false
              })
                  .catch(() => {
                    this.uploading = false
                  })
            })
            .catch(() => {
              this.uploading = false
            })

        toast.success('Saved')
      } else {
        this.removeAvatar()
      }
    },
    removeAvatar() {
      document.getElementById('photoUploadButton')?.click()
      const companyInfo = this.companyStore.getCompanyInfo;
      if (companyInfo.companyImage) {
        this.uploading = true
        this.companyStore.removeCompanyAvatar(companyInfo.companyImage)
            .then(() => {
              this.uploading = false
              this.companyStore.loadCompanyInfo({workspaceId: this.workspaceStore.getSelectedWorkspaceId}).then(() => {
                this.uploading = false
              })
                  .catch(() => {
                    this.uploading = false
                  })
            }).catch(() => this.uploading = false)
      }
    }
  }
})

</script>
<style lang="scss" scoped>

.buttons {
  .btn {
    margin: var(--space-0);
  }
}

.workspaceurl {
  color: var(--text-neutral);
}

.user-name {
  font-weight: 600;
  margin-bottom: 15px;
}

.user-avatar {
  overflow: hidden;
  width: 140px;
  height: 140px;
  position: relative;
  mask-image: url("data:image/svg+xml,%3Csvg clip-rule='evenodd' fill-rule='evenodd' viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m18.947 18.947c-13.32 13.32-17.947 42.57-17.947 109.053s4.626 95.732 17.947 109.053c13.32 13.32 42.57 17.947 109.053 17.947s95.732-4.626 109.053-17.947c13.32-13.32 17.947-42.57 17.947-109.053s-4.626-95.732-17.947-109.053c-13.32-13.32-42.57-17.947-109.053-17.947s-95.732 4.626-109.053 17.947z' fill-rule='nonzero' stroke='%23000' transform='matrix(.992126 0 0 .992126 1.00787 1.00787)'/%3E%3C/svg%3E");
  mask-position: center center;
  mask-repeat: no-repeat;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  & > img {
    background-color: rgb(244, 244, 245);
    border-radius: $br-xs;
    display: block;
    height: 100%;
    margin: 0px;
    padding: 0px;
    position: relative;
    width: 100%;
    z-index: 0;
  }

  & > .text-avatar {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 140px;
    height: 140px;
    color: var(--text-light);
    background: var(--neutral-200);
    font-size: var(--fs-24);
    font-weight: 700;
    mask-image: url("data:image/svg+xml,%3Csvg clip-rule='evenodd' fill-rule='evenodd' viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m18.947 18.947c-13.32 13.32-17.947 42.57-17.947 109.053s4.626 95.732 17.947 109.053c13.32 13.32 42.57 17.947 109.053 17.947s95.732-4.626 109.053-17.947c13.32-13.32 17.947-42.57 17.947-109.053s-4.626-95.732-17.947-109.053c-13.32-13.32-42.57-17.947-109.053-17.947s-95.732 4.626-109.053 17.947z' fill-rule='nonzero' stroke='%23000' transform='matrix(.992126 0 0 .992126 1.00787 1.00787)'/%3E%3C/svg%3E");
    mask-position: center center;
    mask-repeat: no-repeat;

    h1 {
      color: var(--text-light);
      margin: var(--space-0);
    }
  }
}

</style>
